import React from "react";

export function HeadingText({ text }) {
    return (
      <div className="mt-4 mb-2 baseText !font-medium max-w-xs">{text}</div>
    );
  }

export function Paragraph({ text }) {
    return <p className="baseText text-navLink">{text}</p>;
  }